import type { FullPage } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import { useMatchedExtension } from '@atlassian/jira-spa-apps-forge-common/src/controllers/index.tsx';
import { useRouter } from '@atlassian/react-resource-router';

export const useForgeSelectedApp = (modules: FullPage[] | null, routeName?: string) => {
	const [{ match, route }] = useRouter();
	const matchedExtension = useMatchedExtension({ modules, match });

	if (route.name !== routeName || matchedExtension == null) {
		return null;
	}

	return matchedExtension;
};
